module.exports = __webpack_public_path__ + "img/Frame 5112.0ace9332.jpg";